// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.area_bZE79 {
  padding-top : 160px;
}

.search_xK4BJ {
  align-self: center;
  width : 90vw;
  max-width : 640px;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/screens/simpleSearch/DesktopSimpleSearchScreen.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB","sourcesContent":[".area {\n  padding-top : 160px;\n}\n\n.search {\n  align-self: center;\n  width : 90vw;\n  max-width : 640px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"area": `area_bZE79`,
	"search": `search_xK4BJ`
};
export default ___CSS_LOADER_EXPORT___;
